import React, { useEffect, useState, useRef } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { FaEye, FaEyeSlash } from "react-icons/fa";

import { addEditData } from "../../../controllers/cms/founder";
import { fetchIpAddress } from "../../../controllers/API";
import imageCompression from "browser-image-compression";
import LoadingEffect from "../../../components/Loading/LoadingEffect";
import { beforeUpload } from "../../../controllers/common";

const UserListEditPage = () => {
  const { Option } = Select;
  const { Dragger } = Upload;
  const targetRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);
  const [image, setImage] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [pages, setPages] = useState(["early", "primary", "middle", "senior"]);
  // const [pages, setPages] = useState([
  //   { value: "early", label: "early" },
  //   { value: "primary", label: "primary" },
  //   { value: "middle", label: "middle" },
  //   { value: "senior", label: "senior" },
  // ]);
  /*********************************************************
   *  This function is use to handle imput chnage
   *********************************************************/
  const handleChange = (e) => {
    setAddEditSata((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const handleImageChnage = (e) => {
    const fileList = e.fileList; // Keep only the last image
    setImage(fileList);
    if (fileList.length === 0) {
      setError(prev => ({ ...prev, image: "Image is required." }));
    } else {
      setError(prev => ({ ...prev, image: "" }));
    }
  };

  /*********************************************************
   *  This function is used to handle image upload and compression
   *********************************************************/
  const handleImageChange = async (info) => {
    const file = info.file.originFileObj || info.file;

    if (info.file.status === "removed") {
      return; // Ignore remove events
    }
    // Validate file type and size
    if (!file.type.startsWith("image/")) {
      setError((prev) => ({ ...prev, image: "Please upload a valid image file." }));
      return;
    }

    if (file.size > 5 * 1024 * 1024) {
      setError((prev) => ({ ...prev, image: "Image must be smaller than 5MB." }));
      return;
    }

    // Compress the image
    const options = {
      maxSizeMB: 1, // Maximum size in MB after compression
      maxWidthOrHeight: 1024, // Maximum width or height
      useWebWorker: true, // Use web worker for better performance
    };

    try {
      const compressedFile = await imageCompression(file, options);
      const newFile = {
        ...file,
        originFileObj: compressedFile, // Replace the original file with the compressed one
      };
      setImage((prev) => [...prev, newFile]);
      setError((prev) => ({ ...prev, image: "" }));
    } catch (error) {
      console.error("Error compressing image:", error);
      setError((prev) => ({ ...prev, image: "Failed to compress image." }));
    }
  };
  const handleRemove = (file) => {
    setImage((prev) => prev.filter((img) => img.uid !== file.uid)); // Remove specific image
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
    try {
      const {
        _id,
        banner_title,
        content,
        vision_content,
        video_link,
        founder_message,
      } = ADDEDITDATA;
      const ipAddress = (await fetchIpAddress()) || "0.0.0.0";

      const form = new FormData();
      if (_id && _id !== "undefined" && _id !== null) {
        form.append("editId", _id);
      }
      if (image) {
        image.forEach((item, index) => {
          form.append(`image`, item.originFileObj);
        });
      }
      form.append("banner_title", banner_title);
      form.append("content", content);
      form.append("vision_content", vision_content);
      form.append("video_link", video_link);
      form.append("founder_message", founder_message);
      form.append("ipAddress", ipAddress);

      const isValidate = validateFormData(form);
      if (isValidate) {
        const options = {
          url: `cms/kcfounder/addeditdata/${_id?_id:':editId'}`,
          postData: form,
        };
        const res = await addEditData(options);
        if (res.status === true) {
          notification.open({
            message: "Data added.",
            description: `Data added successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/founder");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    } finally {
      setIsLoading(false);
    }
  };


  const validateFormData = (form) => {
    if (!form.get("banner_title").trim() || form.get("banner_title").trim() === "undefined" || form.get("banner_title").trim() === null) {
      setError((preError) => ({
        ...preError,
        banner_title: "Title is required",
      }));
      return false;
    }

    if (!form.get("content").trim() || form.get("content").trim() === "undefined" || form.get("content").trim() === null) {
      setError((preError) => ({
        ...preError,
        content: "Banner content is required",
      }));
      return false;
    }

    if (!form.get("vision_content").trim() || form.get("vision_content").trim() === "undefined" || form.get("vision_content").trim() === null) {
      setError((preError) => ({
        ...preError,
        vision_content: "Vision content is required",
      }));
      return false;  
    }

    if (!form.get("video_link").trim() || form.get("video_link").trim() === "undefined" || form.get("video_link").trim() === null) {
      setError((preError) => ({
        ...preError,
        video_link: "Video link is required",
      }));
      return false;
    }

    if (!form.get("founder_message").trim() || form.get("founder_message").trim() === "undefined" || form.get("founder_message").trim() === null) {
      setError((preError) => ({
        ...preError,
        founder_message: "Founder message link is required",
      }));
      return false;
    }
    return true;
  };




  useEffect(() => {
    targetRef.current.scrollIntoView({
      behavior: 'smooth',
    });
    if(ADDEDITDATA?._id){
      console.log(ADDEDITDATA?.page);
    }
    document.title = `KC High Admin || ${ADDEDITDATA?._id ? "Edit" : "Add"
      } About Founder`;
  }, [ADDEDITDATA]);
  return (
    <div ref={targetRef}>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              {ADDEDITDATA?._id ? `Edit` : `Add`} About Founder
            </h5>
          </div>
          <Link to="/cms/founder">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  <div className="row">
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="banner_title"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Banner title :{" "}
                      </label>
                      <input
                        title="Enter banner title"
                        placeholder="Enter banner title"
                        type="text"
                        name="banner_title"
                        className="form-control store_input_field"
                        id="banner_title"
                        value={ADDEDITDATA?.banner_title}
                        onChange={handleChange}
                      />
                      {error.banner_title ? (
                        <p style={{ color: "red" }}>
                          {error.banner_title}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="content"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Banner content :
                      </label>
                      <textarea
                        title="Enter banner content"
                        placeholder="Enter banner content"
                        type="text"
                        name="content"
                        className="form-control store_input_field"
                        id="content"
                        value={ADDEDITDATA?.content}
                        onChange={handleChange}
                        rows={5}
                      />
                      {error.content ? (
                        <p style={{ color: "red" }}>{error.content}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="video_link"
                        className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Video link :{" "}
                      </label>
                      <input
                        title="Enter video link"
                        placeholder="Enter video link"
                        type="text"
                        name="video_link"
                        className="form-control store_input_field"
                        id="video_link"
                        value={ADDEDITDATA?.video_link}
                        onChange={handleChange}
                      />
                      {error.video_link ? (
                        <p style={{ color: "red" }}>
                          {error.video_link}
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="founder_message"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Founder message :
                      </label>
                      <textarea
                        title="Enter founder message"
                        placeholder="Enter founder message"
                        type="text"
                        name="founder_message"
                        className="form-control store_input_field"
                        id="founder_message"
                        value={ADDEDITDATA?.founder_message}
                        onChange={handleChange}
                      />
                      {error.founder_message ? (
                        <p style={{ color: "red" }}>{error.founder_message}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                      <label
                        htmlFor="vision_content"
                        className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                      >
                        <span style={{ color: "red" }}>*</span>Founder Vision :
                      </label>
                      <textarea
                        title="Enter vision content"
                        placeholder="Enter vision content"
                        type="text"
                        name="vision_content"
                        className="form-control store_input_field"
                        id="vision_content"
                        value={ADDEDITDATA?.vision_content}
                        onChange={handleChange}
                      />
                      {error.vision_content ? (
                        <p style={{ color: "red" }}>{error.vision_content}</p>
                      ) : (
                        ""
                      )}
                    </div>
                    <div className="form-group">
                  <label
                    htmlFor="exampleInputPassword1"
                    className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                  >
                    {!ADDEDITDATA?._id && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                    Images
                  </label>
                  <Dragger
                    className="about_us_dragger_file"
                    maxCount="3"
                    multiple={true}
                    listType="picture-card"
                       onChange={handleImageChange}
                                        fileList={image}
                                        beforeUpload={() => false} // Prevent automatic upload
                                        onRemove={handleRemove} 
                  >
                    <button
                      type="button"
                      className="about_us_dragger_file_button"
                    >
                      Upload file
                    </button>
                  </Dragger>
                  <p
                    style={{ color: "blue" }}
                    className="all_top_and_bottom_for_input_text"
                  >
                    *Note: Please select an image format (JPEG/JPG/PNG).
                  </p>
                  {error.image ? (
                    <p style={{ color: "red" }}>{error.image}</p>
                  ) : (
                    ""
                  )}
                </div>
                  </div>
                </div>
                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <LoadingEffect isLoading={isLoading} />
    </div>
  );
};

export default UserListEditPage;
